import React from "react";
import { Tabs } from "antd";

import { FollowUpLeadsTabs } from "../../utils/constants";
import { useSelector } from "react-redux";

const FollowUpLeadsHome = () => {
	const {organizationData} = useSelector(state => state.organization)
	const isHCP = organizationData?.organization_provider === "HCP"
	return (
		<Tabs
		    destroyInactiveTabPane
			items={FollowUpLeadsTabs.filter(item => isHCP ? item.name !== "ServiceTitan Integration" : item).map((item) => {
				return {
					key: item.name,
					label: (
						<span>
							{item.icon} {item.name}
						</span>
					),
					children: item.component,
				};
			})}
		/>
	);
};

export default FollowUpLeadsHome;
